export default __webpack_public_path__ + "static/media/filrep02.5610c6f1.png";